import React from 'react';
import Menu from '../Screens/Menu.js';
import '../assets/css/Order.css';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid'
import AttachmentsTable from '../components/Table/AttachmentsTable.js';
import axios from 'axios'
import { toast, } from 'react-toastify';
import { BASE_URL } from "../utils/handleApi";

const useStyles = theme => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            marginBottom: theme.spacing(10)
        }
    },
    back: {
        color: 'red',
        marginTop: '30%'
    },
});

class AddProduct extends React.Component {

    state = {
        showingAttachments: true,
        arrLinks: [],
        loading: false,
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        this.setState({ loading: true });
        const tokenStr = localStorage.getItem('token');
        axios.post(`${BASE_URL}/order/${this.state.showingAttachments ? "attachments" : "orderUpdates"}`,{
          'order_id': this.props.match.params.orderId
        },{
            headers: {
                'Authorization': `Bearer ${tokenStr}` 
            }
        })
        .then(res => {
          res.data.map(linkData => {
            let links;
            if(this.state.showingAttachments){
                links = linkData.order_attachments.map((number) => ({ link : number.link, }))
                return this.setState({
                    arrLinks : links
                })
            } else {
                links = linkData.order_updates.map((number) => ({ link : number.link, }))
                return this.setState({
                    arrLinks : links
                })
            }
            
          })
          this.setState({ loading: false})
        })
        .catch(err => {
          this.setState({ loading: false })
          toast.error('Some error happened!')
        });  
    }

    render() {
        const { comp_order } = this.props.location.state;
            return (
                <div style={{ backgroundColor: 'white', height: '100%' }}>
                    <Grid container>
                        <Grid item>
                            <div>
                                <Menu comp_order={comp_order}  />
                            </div>
                        </Grid>
                    </Grid>
                    <div className="mdata">
                    <Grid container >
                            <Grid item xs={12}>
                                <h2 className="mtextOpenOrder">
                                    {this.state.showingAttachments ? "Attachments": "Order Updates"}
                                </h2>
                                    <div style={{textAlign: "right"}}>
                                        <Button 
                                        variant="contained" 
                                        style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', 
                                            color: 'white', height: '50px', fontFamily: 'Roboto-Bold', 
                                            backgroundColor: '#04AB23', textTransform: 'none', textAlign: 'center', marginBottom: '10px', marginRight: "10px" }}
                                        onClick={() => {
                                            this.setState({ showingAttachments: !this.state.showingAttachments },
                                                () => this.fetchData()
                                            )}}
                                        >
                                            {this.state.showingAttachments ? "Show Order Updates": "Show Attachments"}
                                        </Button>
                                        <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', 
                                            color: 'white', height: '50px', width: '120px', fontFamily: 'Roboto-Bold', 
                                            backgroundColor: '#04AB23', textTransform: 'none', textAlign: 'center', marginBottom: '10px' }} 
                                            onClick={this.props.history.goBack}
                                        >
                                            Back
                                        </Button>
                                    </div>
                            </Grid>
                        </Grid>
                        

                        <Grid container style={{ backgroundColor: 'white' }}>
                            <Grid item>
                                <div>
                                    <AttachmentsTable
                                        showingAttachments={this.state.showingAttachments}
                                        arrLinks={this.state.arrLinks}
                                        loading={this.state.loading}
                                    />
                                </div>
                            </Grid>
                        </Grid>

                        
                    </div>

                </div>
            );
        }

}

export default withStyles(useStyles, { withTheme: true })(AddProduct)